import React, {Component} from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./style.scss";

export default class Editor extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.modules = {
      toolbar: [
        [
          {header: [1, 2, 3, false]},
          "bold",
          "italic",
          "underline",
          {list: "ordered"},
          {list: "bullet"},
          {background: []},
          {color: []},
          "link"
        ]
      ]
    };
  }

  handleChange(value, delta, source, editor) {
    this.props.onChange({name: this.props.name, value});
  }

  render() {
    const {label, value, disabled} = this.props;
    return (
      <div className="Editor">
        {label && <label className="field-label">{label}</label>}
        <ReactQuill
          defaultValue={value}
          // value={value}
          onChange={this.handleChange}
          modules={this.modules}
          placeholder="Add notes"
          theme={"snow"}
          readOnly={disabled}
        />
      </div>
    );
  }
}

Editor.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/pages/Facility/Editor/index.jsx